// The `?url` suffix (typed in types/css-url.d.ts) is what makes Vite emit
// this stylesheet as its own hashed asset and hand back its URL, instead of
// bundling it into dist/assets/main*.css like a plain CSS import would.
import stylesUrl from '../../styles/reimagined/index.css?url';

let injected = false;

/**
 * Loads the `/reimagined/*` prototype's CSS (styles/reimagined/index.css)
 * into the current page, once per session.
 *
 * Call this from the reimagined route tree and from the two production
 * components spliced out of it — ReimaginedLoanSummary
 * (app/components/reimagined/production/loan-summary.gts) and
 * DocumentCenter (app/components/reimagined/document-center.gts, which
 * ReimaginedDocumentCenter wraps) — everywhere else, production routes never
 * pay for prototype CSS they don't render. journeys.css is NOT bundled here:
 * app/components/slr/contribution-history.gts (a shipped, non-reimagined
 * component) reaches a few of its classes indirectly through
 * career-pathways-api.ts, so it stays in the always-loaded bundle via
 * styles/app.css instead of moving here.
 *
 * Idempotent and safe to call from every render — the `<link>` is appended
 * at most once per page load, and the browser dedupes the request even if
 * two callers race before the first append lands.
 */
export function ensureReimaginedStylesLoaded(): void {
  if (injected) return;
  injected = true;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = stylesUrl;
  link.dataset['reimaginedStyles'] = 'true';
  document.head.append(link);
}
